"use client"
import { useTranslation } from "react-i18next";
import { Modal } from "antd";

interface AboutDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function AboutDialog({ open, onOpenChange }: AboutDialogProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={() => onOpenChange(false)}
      footer={null}
      width={768}
      centered
      destroyOnHidden
      title={
        <span className="text-2xl md:text-3xl font-bold text-font-primary bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent">
          {t('about.title')}
        </span>
      }
    >
      <div className="max-h-[60vh] overflow-y-auto">
        <div className="space-y-6 mt-4">
          <div className="space-y-6 text-font-primary leading-relaxed text-base">
            <p className="mb-6">{t('about.content1')}</p>
            <p className="mb-6">{t('about.content2')}</p>
            <p className="mb-6 last:mb-0">{t('about.content3')}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
